import { useState, useEffect } from 'react';

/**
 * Hook for fetching conversation data
 * @param {string} conversationId - Conversation ID
 * @returns {Object} Conversation data, loading state, and error
 */
const useFetchConversationData = (conversationId) => {
  const [conversationData, setConversationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConversationData = async () => {
      if (!conversationId) {
        setConversationData(null);
        setLoading(false);
        return;
      }
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/conversations/${conversationId}`, {
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });
        
        if (response.ok) {
          const data = await response.json();
          setConversationData(data.data);
        } else {
          setError('Error fetching conversation data');
          setConversationData(null);
        }
      } catch (error) {
        setError(error.message);
        setConversationData(null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchConversationData();
  }, [conversationId]);

  return {
    conversationData,
    setConversationData,
    loading,
    error
  };
};

export default useFetchConversationData;

